const options = [
	{ value: 2.0, label: 'sim, espetacular <span class="emoji">😍</span>' },
	{ value: 2.5, label: 'estamos quase lá <span class="emoji">😃</span>' },
	{ value: 3.5, label: 'falta pouco <span class="emoji">🙂</span>' },
	{ value: 4.5, label: 'mais ou menos…' },
	{ value: 5.8, label: 'infelizmente não <span class="emoji">😐</span>' },
];

const InterestRateDropdown = (params: any) => {

	const render = () => {
		const container = document.querySelector('.c-rate-dropdown__inner') as HTMLElement;

		const option = options
			.filter(o => o.value === params.interestRate)
			.map(o => o.label)[0] ?? '';

		container.innerHTML = `
			<span class="label">${option}</span>
			<span class="text-gray-4">${params.interestRate.toFixed(1).replace('.', ',')}%</span>
			<i class="icon-chevron text-secondary c-main-menu__icon"></i>
		`;
	}

	document.querySelector('.c-rate-dropdown__selected')?.addEventListener('click', () => {
		document.querySelector('.c-rate-dropdown__items')?.classList.add('c-rate-dropdown__items--opened');
	});

	document.querySelector('.c-rate-dropdown__items')?.addEventListener('click', () => {
		document.querySelector('.c-rate-dropdown__items')?.classList.remove('c-rate-dropdown__items--opened');
	});

	render();

	return { render };
}

export default InterestRateDropdown;